import { Box, Typography } from "@mui/material";
import { ReactComponent as AlertIcon } from "../../assets/icons/circle-alert.svg";

function ErrorMessageText({ sx = [], ...props }) {
  const { errorMessage } = props;
  return (
    <>
      {!!errorMessage && (
        <Box
          sx={[
            {
              display: "flex",
              alignItems: "center",
            },
            ...(Array.isArray(sx) ? sx : [sx]),
          ]}
        >
          <AlertIcon width={16} height={16} />
          <Typography ml={1} variant="subtitle1" color="red.main">
            {errorMessage}
          </Typography>
        </Box>
      )}
    </>
  );
}

export default ErrorMessageText;
